var exports = {
  "kL": "xe7b6e3d6--e3ceb7--container",
  "Kk": "xe7b6e3d6--e3ceb7--icon",
  "DD": "xe7b6e3d6--e3ceb7--title",
};

module.exports = exports;
